var exports = {
  "kL": "x4ddf2309--9e85bf--container",
  "DP": "x4ddf2309--9e85bf--container-mobile",
  "Kk": "x4ddf2309--9e85bf--icon",
  "vr": "x4ddf2309--9e85bf--icon-mobile",
  "Qs": "x4ddf2309--9e85bf--content",
};

module.exports = exports;
